import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { formatMsisdn } from "../../../../tools/tools";
import { ShopReceipt, toman } from "../../../auxiliary/shop/ShopPage";

const EPFinal = () => {
	const [t] = useTranslation("global");
	const { state } = useLocation();
	return (
		<ShopReceipt
			title={t("extraPackage.title")}
			prefix="sp"
			purchase={state?.purchase}
			rows={[
				["نوع سرویس", <>خرید بسته</>],
				["شماره سیم کارت", <span dir="ltr">{formatMsisdn(state?.epmsisdn?.toString())}</span>],
				["عنوان بسته", <span dir="ltr">{state?.packagename}</span>],
				["مبلغ بسته", toman(state?.amount)],
				["کد پیگیری", <span dir="ltr">{state?.eppurchasefollowupcode}</span>],
			]}
		/>
	);
};

export default EPFinal;
